import React from "react";

// Rendu minimal du Markdown des CGU (titres, listes, citations, gras, liens).
const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\((?:https?:\/\/|\/(?!\/)|mailto:)[^)\s]+\)|https?:\/\/[^\s)]+[^\s).,;]|[\w.+-]+@[\w-]+\.[\w.]+[a-z])/g;
const linkCls = "font-bold text-primary underline underline-offset-2";
const inline = (text, key) => text.split(TOKEN).map((part, i) => {
  const k = `${key}-${i}`;
  if (part.startsWith("**") && part.endsWith("**")) return <strong key={k} className="font-black text-foreground">{part.slice(2, -2)}</strong>;
  const md = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
  if (md) return <a key={k} href={md[2]} target={md[2].startsWith("/") ? undefined : "_blank"} rel="noreferrer" className={linkCls}>{md[1]}</a>;
  if (/^https?:\/\//.test(part)) return <a key={k} href={part} target="_blank" rel="noreferrer" className={linkCls}>{part}</a>;
  if (/^[\w.+-]+@[\w-]+\.[\w.]+$/.test(part)) return <a key={k} href={`mailto:${part}`} className={linkCls}>{part}</a>;
  return <React.Fragment key={k}>{part}</React.Fragment>;
});

export default function CguContent({ content = "", testid = "cgu-content" }) {
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };
  content.split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    if (line.startsWith("- ")) {
      if (!list) list = { type: "ul", items: [], key: i };
      list.items.push(line.slice(2));
      return;
    }
    flush();
    if (!line.trim() || line.trim() === "---") return;
    if (line.startsWith("### ")) blocks.push({ type: "h3", text: line.slice(4), key: i });
    else if (line.startsWith("## ")) blocks.push({ type: "h2", text: line.slice(3), key: i });
    else if (line.startsWith("# ")) blocks.push({ type: "h2", text: line.slice(2), key: i });
    else if (line.startsWith("> ")) blocks.push({ type: "quote", text: line.slice(2), key: i });
    else blocks.push({ type: "p", text: line, key: i });
  });
  flush();

  return (
    <div className="font-[Manrope] text-[14px] leading-relaxed text-foreground/85" data-testid={testid}>
      {blocks.map((b) => {
        if (b.type === "h2") return <h2 key={b.key} className="mt-7 mb-2 font-[Outfit] text-[19px] font-black leading-tight text-foreground">{inline(b.text, b.key)}</h2>;
        if (b.type === "h3") return <h3 key={b.key} className="mt-5 mb-1.5 font-[Outfit] text-[16px] font-black text-foreground">{inline(b.text, b.key)}</h3>;
        if (b.type === "quote") return <blockquote key={b.key} className="my-3 rounded-xl bg-[#FFE9D6] px-3 py-2 text-[13px] font-semibold">{inline(b.text, b.key)}</blockquote>;
        if (b.type === "ul") return <ul key={b.key} className="my-2 list-disc space-y-1 pl-5">{b.items.map((it, j) => <li key={j}>{inline(it, `${b.key}-${j}`)}</li>)}</ul>;
        return <p key={b.key} className="my-2">{inline(b.text, b.key)}</p>;
      })}
    </div>
  );
}
